import { RoadDetailInfo as L2RSegmentDetailInfo } from "@l2r-front/l2r-networks"
import { styledForMobile } from "@l2r-front/l2r-ui"

import { RoadsideTypeList as L2RRoadsideTypeList } from "../../containers/RoadsideTypeList"

export const RoadsideTypeList = styledForMobile(L2RRoadsideTypeList)(({ isMobile, theme }) => ({
    padding: !isMobile && theme.spacing(5, 0),
}))

export const RoadDetailInfo = styledForMobile(L2RSegmentDetailInfo)(({ isMobile, theme }) => ({
    marginBottom: isMobile && theme.spacing(1),
}))

export const Container = styledForMobile("div")(({ isMobile, theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(5),
    padding: !isMobile && theme.spacing(5, 0, 0, 0),
}))